import { Config } from "../../../../utils/config";
export const createTranslationKey = (experienceType, sectionType, translationKey, i) => {
  return `EXPERIENCE.${experienceType.toUpperCase()}.${sectionType.toUpperCase()}.${Config.getUniqueId().toUpperCase()}.${translationKey.toUpperCase()}_${i}`;
};
export const createTranslationInputArrayKey = (experienceType, sectionType, translationKey) => {
  return `EXPERIENCE.${experienceType.toUpperCase()}.${sectionType.toUpperCase()}.${Config.getUniqueId().toUpperCase()}.${translationKey.toUpperCase()}`;
};
